import React from "react";

const PageHeader = ({ title, subtitle, breadcrumb, note, children }) => (
  <section className="bg-gradient-to-b from-[#06142e] via-[#0a1f44] to-[#0a1f44] relative overflow-hidden tex-grid-dark">
    <div className="absolute -top-24 -right-16 w-[28rem] h-[28rem] rounded-full bg-[#3b9dff]/20 blur-[110px] pointer-events-none" />
    <div className="absolute -bottom-32 left-10 w-72 h-72 rounded-full bg-[#3b9dff]/10 blur-[90px] pointer-events-none" />
    <div className="max-w-[1280px] mx-auto px-5 lg:px-8 py-12 md:py-16 relative">
      <p className="text-[#7dc4ff] text-sm font-medium mb-3">{breadcrumb}</p>
      <h1 className="text-3xl md:text-5xl font-extrabold text-white leading-tight max-w-3xl">
        {title}
      </h1>
      {subtitle && (
        <p className="text-slate-300 mt-4 max-w-2xl text-lg">{subtitle}</p>
      )}
      {note && (
        <p className="text-slate-400 mt-3 max-w-2xl text-base">{note}</p>
      )}
      {children}
    </div>
    <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#3b9dff]/50 to-transparent" />
  </section>
);

export default PageHeader;
